import React from "react"
import { useForm, FormProvider } from "react-hook-form"
import SignUpFindAccountPage from "components/signup-find-account"
import { SignUpFindAccountProvider } from "components/signup-find-account/context/SignUpFindAccountContext"
import { useHistory } from "react-router"
import { useSignUpFlow } from "components/context/signup/SignUpFlowContext"

const SignUpFindAccount = () => {
  const history = useHistory()
  const formMethods = useForm({ reValidateMode: "onSubmit" })
  const { handleSaveMemberInfoInMemory } = useSignUpFlow()
  const { handleSubmit } = formMethods

  function onEmailFound(email) {
    history.push(`/signup-success?email=${encodeURIComponent(email)}`)
  }

  function onEmailNotFound(email, dateOfBirth, firstName, lastName) {
    handleSaveMemberInfoInMemory({ email, dateOfBirth, firstName, lastName })
    history.push("/signup-find-account-success")
  }

  function onMultipleEmployeesFound() {
    history.push("/signup-get-help")
  }

  function onEmployeeAlreadyRegistered() {
    history.push("/signup-employee-already-registered")
  }

  return (
    <SignUpFindAccountProvider
      {...{ handleSubmit, onEmailFound, onEmailNotFound, onMultipleEmployeesFound, onEmployeeAlreadyRegistered }}
    >
      <FormProvider {...formMethods}>
        <SignUpFindAccountPage />
      </FormProvider>
    </SignUpFindAccountProvider>
  )
}

export default SignUpFindAccount
